import styles from "@/components/footer.module.css";
import * as signals from "@/signals";
import { updateSettings } from "@/utils";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

function Footer(): JSX.Element {
	const disableFooter = (): void => {
		void updateSettings({
			isFooterEnabled: false,
		});
	};

	if (!signals.generalSettings.value.isFooterEnabled) {
		return <></>;
	}
	return (
		<footer className={clsx(styles["footer"], "fade-in")}>
			<a
				className={styles["link"]}
				href="https://beian.miit.gov.cn"
				rel="noreferrer"
				target="_blank"
				title="工业和信息化部域名信息备案管理系统"
			>
				闽ICP备16025935号-2
			</a>
			<span className={styles["divider"]}></span>
			<a
				className={styles["link"]}
				href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010202001376"
				rel="noreferrer"
				target="_blank"
				title="全国互联网安全管理服务平台"
			>
				闽公网安备35010202001376号
			</a>
			<button
				className={styles["close-button"]}
				title={t("close")}
				type="button"
				onClick={disableFooter}
			>
				<FontAwesomeIcon icon={faXmark} />
			</button>
		</footer>
	);
}

export default Footer;
